"use client";

import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Person } from "../../../sanity/lib/types/peopleHero";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import useIsMobile from "../../hooks/useIsMobile";
import { HeroPeopleMobile } from "./heroPeopleMobile";
import { HeroPeopleDesktop } from "./heroPeopleDesktop";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(useGSAP);

export interface HeroPeopleProps {
    title: string;
    people: Array<Person>;
}

export const HeroPeople = ({ title, people }: HeroPeopleProps) => {
    const { isMobile } = useIsMobile();

    if (isMobile) {
        return <HeroPeopleMobile title={title} people={people} />;
    } else {
        return <HeroPeopleDesktop title={title} people={people} />;
    }
};
